import styled from "styled-components";


const InternoBanner = styled.section`
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 20px 0 20px;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    @media (min-width: 996px) {
        padding: 20px 0 100px;
    }

    & h1{
        font-size: 40px;
        font-weight: 900;
        line-height: 1.1;
    }

    &:before{
        content: "";
        inset: 0;
        position: absolute;
        background: #0000005e;
        pointer-events: none;
    }

    @media(min-width:996px){
        &:before{
            background: none;   
        }
        & h1{
            font-size: 70px;
        }
    }
`

const Flexmidbanner = styled.div`
    display: flex;
    margin: 10px 0;
    flex-direction: column;
    grid-gap: 5px;

    & a{
        color: #fff;
        text-decoration: none;
        transition: 0.3s linear;
    }

    & a:hover{
        color: #af5e20;
    }
    
    @media(min-width: 996px){
        align-items: center;
        grid-gap: 60px;
        flex-direction: row;
    }
`

const Tags = styled.span`
    color: #fff;
    display: inline-block;
    width: 100%;
    margin: 20px 0;
    font-weight: 200;
`

const Navcommand = styled.nav`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 40px 0;
    grid-gap: 30px;
    & a{
        width: 0;
        height: 0;
        border-top: 25px solid transparent;
        border-bottom: 25px solid transparent;
        border-left: 25px solid #fff;
        background: none;
        border-right: 0;
        transition: 0.3s linear;
    }

    & a:hover{
        border-left: 25px solid #cc691e;

    }

    & a:first-child{
        transform: rotate(180deg);
    }

    & span{
        width: 0.3px;
        height: 80px;
        position: relative;
        background: #fff;
    }
`

const Paragrafoint = styled.p`
    color: #fff;
    display: inline-block;
    width: 100%;
`

const Desctablet = styled.p`
    color: #fff;
    font-size: 16px;
    font-weight: 300;
    margin: 20px 0;
    padding: 0 15px;
    line-height: 1.6em;

    @media(min-width:996px){
        margin: 40px 0;
        padding: 0;
    }
`

const Btnnav = styled.span`
    color: #fff;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    grid-gap: 9px;
    transition: 0.3s linear;

    & span{
        font-weight: 100;
        font-size: 14px;
    }

    & h3{
        font-weight: 600;
    }

    &:hover{
        color:#cc691e;
    }
`

const Sectioninterna = styled.section`
   padding: 20px 0;

   &:first-child{
    padding: 40px 0 20px;
   }
`

export { Sectioninterna, Btnnav, Desctablet, Paragrafoint, Navcommand, Tags, Flexmidbanner, InternoBanner };
